import { useState, useEffect } from 'react';
import config from '../../../config/config';

export function FindShare() {
  const [formData, setFormData] = useState({
    animalType: '',
    customerId: '',
    firstName: '',
    lastName: '',
    phone: '',
    animalNumber: '',
    subCategory: '',
    day: ''
  });
  const [shareDetails, setShareDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // --- 1. COMMON FETCH FUNCTION (For both Initial Load & Search) ---
  const fetchShares = async (filters = {}) => {
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('token');

      const response = await fetch(`${config.baseUrl}/api/moderator/find-share`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(filters)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Data fetch karne mein masla hua');
      }

      // Backend response handle karein (result.data ya direct array)
      const rawData = result.data || result.shares || result;
      const finalArray = Array.isArray(rawData) ? rawData : (rawData ? [rawData] : []);

      setShareDetails(finalArray);
      if (finalArray.length === 0) setError("Koi records nahi mile.");

    } catch (err) {
      console.error("Fetch Error:", err);
      setError(err.message);
      setShareDetails([]);
    } finally {
      setLoading(false);
    }
  };

  // --- 2. INITIAL LOAD ---
  useEffect(() => {
    fetchShares({}); // Khali filters bhej rahe hain taake 'All Data' aaye
  }, []);

  // --- 3. INPUT HANDLER ---
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // --- 4. FORM SUBMIT (Search) ---
  const handleSubmit = (e) => {
    e.preventDefault();

    // Sirf wo fields pick karein jin mein user ne kuch likha hai
    const activeFilters = {};
    Object.keys(formData).forEach(key => {
      if (formData[key] && formData[key].toString().trim() !== "") {
        activeFilters[key] = formData[key];
      }
    });

    fetchShares(activeFilters);
  };

  return (
    <div className="min-h-screen p-2 md:p-8 bg-indigo-100/50">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-8">
        <h1 className="text-3xl font-black text-indigo-800 tracking-tight flex items-center gap-3">
          SHARE MANAGEMENT
        </h1>
      </div>

      <div className="max-w-9xl mx-auto grid grid-cols-1 lg:grid-cols-4 gap-4">

        {/* Search Panel */}
        <div className="lg:col-span-0">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 sticky top-8">
            <h2 className="text-sm font-black text-indigo-800 uppercase tracking-widest mb-6">Filters</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-[11px] font-bold text-gray-400 uppercase mb-1 ml-1">Customer ID</label>
                <input
                  type="text"
                  name="customerId"
                  value={formData.customerId}
                  onChange={handleInputChange}
                  className="w-full bg-gray-50 border-2 border-gray-100 rounded-xl p-3 text-sm focus:border-indigo-500 outline-none transition-all"
                  placeholder="e.g. 102"
                />
              </div>

              <div>
                <label className="block text-[11px] font-bold text-gray-400 uppercase mb-1 ml-1">Animal Tag</label>
                <input
                  type="text"
                  name="animalNumber"
                  value={formData.animalNumber}
                  onChange={handleInputChange}
                  className="w-full bg-gray-50 border-2 border-gray-100 rounded-xl p-3 text-sm focus:border-indigo-500 outline-none transition-all"
                  placeholder="Tag Number"
                />
              </div>

              <div>
                <label className="block text-[11px] font-bold text-gray-400 uppercase mb-1 ml-1">Phone</label>
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="w-full bg-gray-50 border-2 border-gray-100 rounded-xl p-3 text-sm focus:border-indigo-500 outline-none transition-all"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-indigo-800 hover:bg-indigo-700 text-white font-black py-4 rounded-xl shadow-lg transition-all active:scale-95 mt-2"
              >
                {loading ? "SEARCHING..." : "SEARCH RECORDS"}
              </button>
            </form>
          </div>
        </div>

        {/* Results Panel */}
        <div className="lg:col-span-3">
          {error && (
            <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 rounded-r-xl">
              <p className="text-red-700 font-bold text-sm">{error}</p>
            </div>
          )}

          {shareDetails && (
            <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="p-6 bg-gray-50 border-b border-gray-100">
                <h3 className="font-black text-indigo-800 uppercase text-sm tracking-wider">
                  Total Records: {shareDetails.length}
                </h3>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-left">
                  <thead>
                    <tr className="text-[12px] font-black text-white bg-indigo-800 uppercase tracking-wider">
                      <th className="px-6 py-4">ID</th>
                      <th className="px-6 py-4">Customer Name</th>
                      <th className="px-6 py-4">Animal Details</th>
                      <th className="px-6 py-4">Tag/Day</th>
                      <th className="px-6 py-4 text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {shareDetails.map((share, index) => (
                      <tr key={index} className="hover:bg-indigo-50/30 transition-colors">
                        <td className="px-6 py-4 font-black text-indigo-600 text-sm">{share.customer_id}</td>
                        <td className="px-6 py-4">
                          <div className="font-bold text-gray-800">{share.firstname} {share.lastname}</div>
                          <div className="text-[10px] text-gray-400">{share.phone}</div>
                        </td>
                        <td className="px-6 py-4">
                          <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded text-[10px] font-black uppercase">
                            {share.subcat_name || share.cat_name}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <div className="text-xs font-black">TAG: {share.animal_number || 'N/A'}</div>
                          <div className="text-[10px] text-gray-400 uppercase">Day: {share.slaughtering_day}</div>
                        </td>
                        <td className="px-6 py-4 text-center">
                          <button className="text-indigo-400 hover:text-indigo-800 transition-colors">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {shareDetails.length === 0 && !loading && (
                  <div className="p-10 text-center text-gray-400 font-bold uppercase text-xs">No Data Available</div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}